var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotfix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.383,
    height: 8.672,
    viewBox: "0 0 5.383 8.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fire",
    transform: "translate(-97.103 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11363",
    "data-name": "Path 11363",
    d: "M97.1,5.98a2.691,2.691,0,0,0,2.691,2.691h0a2.691,2.691,0,0,0,2.691-2.691c0-1.5-.748-2.691-.246-3.738,0,0-.8.15-1.249,1.346A3.8,3.8,0,0,1,100.12,0a2.422,2.422,0,0,0-1.363,2.542c.136,1.667-.159,1.944-.159,1.944a2.3,2.3,0,0,0-1.052-1.944C97.851,4.186,97.1,4.634,97.1,5.98Z",
    transform: "translate(0 0)",
    fill: "#ffb446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11364",
    "data-name": "Path 11364",
    d: "M153.451,171.5a2,2,0,0,1-1.984,2.054,1.716,1.716,0,0,1-1.753-1.869,4.532,4.532,0,0,1,.972-1.991l.386.234a7.821,7.821,0,0,1,.436-2.205C151.8,169.05,153.451,169.394,153.451,171.5Z",
    transform: "translate(-51.714 -164.884)",
    fill: "#ffdc64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11365",
    "data-name": "Path 11365",
    d: "M185.828,283.38a16.971,16.971,0,0,0-.449,1.794,1.238,1.238,0,0,0,1.2,1.2h0a1.2,1.2,0,0,0,1.2-1.209,3.638,3.638,0,0,0-1.047-2.679,1.565,1.565,0,0,1-.3,1.346A1.52,1.52,0,0,0,185.828,283.38Z",
    transform: "translate(-86.781 -277.699)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotfix);
export default __webpack_public_path__ + "static/media/hotfix.fa45f9e4.svg";
export { ForwardRef as ReactComponent };